/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss'],
})
export class ItemListComponent implements OnInit {
  doctorList: any[];
  doctorRole = 'physician';
  filterdoctorList = [];
  hasSkelton = false;
  filter: any;
  mbsValidateitems = [];
  itemsSelect: any;
  itemsArr = [];
  getSelectedData = [];
  favItems = [];
  showFav = true;

  constructor(
    private apiService: ApiService, 
    public modalController: ModalController, 
    public params: NavParams,
    public storageService: StorageService,
    ) { }

  ngOnInit() {
    this.getSelectedData = this.params.get('selectedVal');
    this.getSelectedData.forEach((element, index) => {
      this.getSelectedData[index] = element.toString();
    });
    this.itemsArr = this.getSelectedData;
    this.mbsValidateitems = [];
    this.getFavItems();
    this.storageService.get('doctor_role').then(res => {
      this.doctorRole = res;
    });
  }
  goBack() {
    this.modalController.dismiss();
  }

  getFavItems() {
    const payload = {
    };
    this.apiService.post('data/favorite-mbs-list', payload).subscribe(
      (res) => {
        //console.log('res', res);
        if (res.error === false) {
          this.favItems = res.data.mbs;
          this.favItems.forEach((element, index) => {
            const checkIndex = this.getSelectedData.findIndex(item => item === this.favItems[index].Mbs.ItemNum);
            if (checkIndex === -1) {
              this.favItems[index].Mbs.checked = false;
            } else {
              this.favItems[index].Mbs.checked = true;
            }
          });
        }
      },
      (err) => {
      }
    );
  }

  getItems(args) {
    if (args) {
      const payload = {
        search: args.target.value,
      };
      this.showFav = false;
      this.hasSkelton = true;
      this.apiService.post('data/check-item-exist', payload).subscribe(
        (res) => {
          this.hasSkelton = false;
          if (res.error === false) {
            this.mbsValidateitems = res.data;
            this.mbsValidateitems.forEach((element, index) => {
              const getIndex = this.getSelectedData.findIndex(item => item === this.mbsValidateitems[index].ItemNum);
              if (getIndex === -1) {
                this.mbsValidateitems[index].checked = false;
              } else {
                this.mbsValidateitems[index].checked = true;
              }
            });
          }
        },
        (err) => {
        }
      );
    }
  }

  checkboxClick(event) {

    const index = this.itemsArr.findIndex(item => item === event.detail.value);
    if (index === -1) {
      if (!event.detail.checked) {
        return;
      }
      this.itemsArr.push(event.detail.value);
    } else {
      this.itemsArr.splice(index, 1);
    }
    
  }

  addItem(value) {
    
      this.itemsArr.push(value);
  }


  removeItem(event) {
    const index2 = this.itemsArr.findIndex(item => item === event);
    this.itemsArr.splice(index2, 1);
  }

  doneItems() {
    this.modalController.dismiss(this.itemsArr);
  }

}
